import { useState, useEffect, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useClients } from "@/hooks/useClients";
import { useSuppliers } from "@/hooks/useSuppliers";

export function useRegisterData() {
  const queryClient = useQueryClient();
  const [categories, setCategories] = useState<any[]>([]);
  const [costCenters, setCostCenters] = useState<any[]>([]);
  const [paymentAccounts, setPaymentAccounts] = useState<any[]>([]);

  // Buscar clientes e fornecedores usando hooks existentes
  const { clients, isLoading: isLoadingClients } = useClients();
  const { suppliers, isLoading: isLoadingSuppliers } = useSuppliers();

  
  const fetchCategories = useCallback(async () => {
    try {
            const { data: user } = await supabase.auth.getUser();

      if (!user || !user.user) {
        console.error('No user authenticated');
        return;
      }

      const { data: categoriesData, error: categoriesError } = await supabase
        .from('categories')
        .select('*')
        .eq('user_id', user.user.id);

      if (categoriesError) {
        console.error('Categories fetch failed:', categoriesError);
        throw categoriesError;
      }

            setCategories(categoriesData || []);
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
    }
  }, []);

  const fetchCostCenters = useCallback(async () => {
    try {
            const { data: user } = await supabase.auth.getUser();

      if (!user || !user.user) {
        console.error('No user authenticated');
        return;
      }

      const { data: costCentersData, error: costCentersError } = await supabase
        .from('cost_centers')
        .select('*')
        .eq('user_id', user.user.id);

      if (costCentersError) {
        console.error('Cost centers fetch failed:', costCentersError);
        throw costCentersError;
      }

            setCostCenters(costCentersData || []);
    } catch (error) {
      console.error('Erro ao buscar centros de custo:', error);
    }
  }, []);

  const fetchPaymentAccounts = useCallback(async () => {
    try {
            const { data: user } = await supabase.auth.getUser();

      if (!user || !user.user) {
        console.error('No user authenticated');
        return;
      }

      const { data: paymentAccountsData, error: paymentAccountsError } = await supabase
        .from('payment_accounts')
        .select('*')
        .eq('user_id', user.user.id);

      if (paymentAccountsError) {
        console.error('Payment accounts fetch failed:', paymentAccountsError);
        throw paymentAccountsError;
      }

            setPaymentAccounts(paymentAccountsData || []);
    } catch (error) {
      console.error('Erro ao buscar contas de pagamento:', error);
      toast.error('Não foi possível carregar as contas de pagamento');
    }
  }, []);

  useEffect(() => {
    fetchCategories();
    fetchCostCenters();
    fetchPaymentAccounts();
  }, [fetchCategories, fetchCostCenters, fetchPaymentAccounts]);

  // Função melhorada para forçar refetch dos clientes
  const refetchClients = useCallback(async () => {
            
    // Invalidar e refetch em sequência para garantir atualização
    await queryClient.invalidateQueries({ queryKey: ["clients"] });
        
    await queryClient.refetchQueries({ queryKey: ["clients"] });
          }, [queryClient]);

  return {
    categories,
    costCenters,
    paymentAccounts,
    clients,
    suppliers,
    fetchCategories,
    fetchCostCenters,
    fetchPaymentAccounts,
    refetchClients,
    isLoadingClients,
    isLoadingSuppliers,
  };
}